import CryptoJS from 'crypto-js';

import { VPPBillingAddress } from '@buy-viasat/redux/src/address';

export function encryptVPPMessage(billingAddress: VPPBillingAddress, seed: string, dataSecret: string): string {
  const secret = CryptoJS.enc.Utf8.parse(dataSecret);
  const base64Seed: string = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(seed));
  const encrypted = CryptoJS.AES.encrypt(JSON.stringify(billingAddress), secret, {
    iv: CryptoJS.enc.Base64.parse(base64Seed),
  });

  return seed + CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
}

export function postVPPMessage(billingAddress: VPPBillingAddress, dataSecret: string) {
  const seed: string = Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10);
  const vppIFrame = document.getElementById('vppIFrame') as HTMLIFrameElement | null;

  return vppIFrame?.contentWindow?.postMessage(
    JSON.stringify({
      vpsAttributes: {
        submitPaymentInfo: 'true',
        billingAddress: encryptVPPMessage(billingAddress, seed, dataSecret),
        useForRecurringPayment: 'true',
        savePaymentInfo: 'true',
        windowUrl: window.location.href,
        windowWidth: 370,
        windowHeight: 330,
      },
    }),
    '*',
  );
}
